import { isConversationProjectionItem, useContentList } from '@/hooks';
import { cn } from '@/lib/utils';

interface ChatUnreadBadgeProps {
  onClick: () => void;
  className?: string;
}

export function ChatUnreadBadge({ onClick, className }: ChatUnreadBadgeProps) {
  const query = useContentList({
    contentTypes: ['NEO_CHAT'],
    limit: 100,
    orderBy: 'timelineAt',
    orderDir: 'desc',
  });
  const count = (query.data?.items ?? []).filter(
    (item) => !isConversationProjectionItem(item) && item.tracking?.isRead !== true
  ).length;
  if (count === 0) {
    return null;
  }
  const label = count > 99 ? '99+' : String(count);
  const ariaLabel = `${count} unread NeoChat${count === 1 ? '' : 's'}`;
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={cn(
        'inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-destructive text-destructive-foreground text-xs font-medium leading-none focus:outline-none focus:ring-2 focus:ring-destructive focus:ring-offset-2',
        className
      )}
    >
      {label}
    </button>
  );
}
